const startsWith=(baseString,searchedString)=>0===baseString.indexOf(searchedString,0);export{startsWith as default};
